import { Box } from '@mui/material';
import { createFileRoute } from '@tanstack/react-router';
import { AuthProvider, SignInPage } from '@toolpad/core';
import { FC } from 'react';

const providers = [{ id: 'google', name: 'Google' }];

const signIn: (provider: AuthProvider) => void = async (provider) => {
    if (provider.id === 'google') {
        window.location.href = `${import.meta.env.VITE_BACKEND_URL}/auth/google`;
    }

    throw new Error('Invalid provider');
};

const RouteComponent: FC = () => {
    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
            }}
        >
            <SignInPage
                signIn={signIn}
                providers={providers}
                sx={{
                    minHeight: 'unset',
                    height: '30vh',
                    minWidth: '40vw',
                    justifyContent: 'center',
                    alignItems: 'center',
                    display: 'flex',
                    '& .MuiButtonBase-root ': {
                        lineHeight: '1',
                    },
                }}
                slots={{
                    title: () => <>Sign in to Hello-Hola</>,
                }}
            />
        </Box>
    );
};

export const Route = createFileRoute('/auth/')({
    component: RouteComponent,
});
